<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="7.2" r="2.8"/><path d="M2.8 16.6c1-2.6 2.8-3.9 5.2-3.9s4.2 1.3 5.2 3.9M14 5.2a2.6 2.6 0 0 1 0 5M15.4 16.6c-.3-1.3-.7-2.3-1.3-3.1"/></svg>
</template>
